import React from "react";
import { useBoolean } from "ahooks";
import { IonIcon, IonSpinner } from "@ionic/react";
import { document as documentIcon, downloadOutline } from "ionicons/icons";
import Lightbox from "../Lightbox";
import { formatSize } from "../../utils/format";
import { ChatAttachment } from "./types";

type DocumentAttachmentProps = { attachment: ChatAttachment };

const PDF_MIME_TYPE = "application/pdf";

const DocumentAttachment = ({ attachment }: DocumentAttachmentProps) => {
  const [open, { setTrue, setFalse }] = useBoolean(false);
  const isPdf = attachment.mimeType === PDF_MIME_TYPE;
  const isPending = attachment.status === "pending";
  const canOpen = !!attachment.signedUrl && !isPending;

  return (
    <>
      <button
        type="button"
        onClick={canOpen ? setTrue : undefined}
        disabled={!canOpen}
        className="flex items-center gap-2 bg-white/70 rounded-lg px-2.5 py-2 text-left max-w-[260px] disabled:opacity-60"
      >
        <div className="relative w-9 h-9 flex items-center justify-center rounded-md bg-primary/10">
          {isPending ? (
            <IonSpinner name="dots" className="text-primary" />
          ) : (
            <IonIcon icon={documentIcon} className="text-2xl text-primary" />
          )}
        </div>
        <div className="flex flex-col min-w-0">
          <span className="text-sm text-black truncate">{attachment.fileName}</span>
          <span className="text-[11px] text-gray-500">{isPending ? "Загрузка…" : formatSize(attachment.fileSize)}</span>
        </div>
      </button>

      {open && attachment.signedUrl && (
        <Lightbox onClose={setFalse}>
          {isPdf ? (
            <iframe
              src={attachment.signedUrl}
              title={attachment.fileName}
              className="w-full h-full sm:w-[90vw] sm:h-[90vh] bg-white rounded-none sm:rounded-lg"
            />
          ) : (
            <div className="w-full h-full sm:w-[420px] sm:h-auto bg-white rounded-none sm:rounded-lg flex flex-col items-center justify-center gap-4 p-6 text-center">
              <IonIcon icon={documentIcon} className="text-6xl text-primary" />
              <div className="font-semibold break-words">{attachment.fileName}</div>
              <div className="text-sm text-gray-500">{formatSize(attachment.fileSize)}</div>
              <a
                href={attachment.signedUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-primary text-white rounded-xl px-4 py-2 text-sm font-bold"
              >
                <IonIcon icon={downloadOutline} /> Открыть
              </a>
            </div>
          )}
        </Lightbox>
      )}
    </>
  );
};

export default DocumentAttachment;
